/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { JOB_TYPE_CONTEXT } from '../JobType/JobType.types';

export type EntityJobContext = io.TypeOf<typeof JobContext>;

export const JobContext = io.type({
  contextName: io.string,
  description: io.string,
  environment: io.record(io.string, io.string),
  type: io.literal(JOB_TYPE_CONTEXT),
});
